export function objectToUrl(object: any) {
  let url = '';
  for (var propertyName in object) {
      const value = object[propertyName];
      url += value !== undefined && value !== null ? (url ? '&' : '') + `${propertyName}=${value}` : '';
  }
  return url ? `?${url}` : '';
}